import React, { useState } from "react";
import { Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  CustomerStatisticsInquiryCriteriaBean,
  CustomerStatisticsPrintRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupARModule,
  PopupCheckBounceModule,
  PopupCreditMemoModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CreditMemoService } from "../services/CreditMemoService.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerStatistics extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Statistics Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new CustomerStatisticsInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowSalesModule: false,
      isShowInvoiceModule: false,
      isShowCreditMemoModule: false,
      isShowCheckBounceModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      isShowCriteriaView: true,
      customerLookupHandler: null,
      agingBucketList: [],
      agingHistoryBean: null,
      onOrderInfoDetail: [],
      salesDetail: [],
      returnCreditMemo: [],
      isShowLastSalesDetailsPopup: false,
      invoiceDetail: [],
      isShowOpenTenderPopup: false,
      isShowOpenReturnPopup: false,
      isShowDiscountPopup: false,
      isShowTotalReturnPopup: false,
      isShowBouncedCheckPopup: false,
      totalReturnDetails: [],
      discountDetails: [],
      openReturnDetails: [],
      openTenderDetails: [],
      bouncedCheck: [],
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      is3PL: false,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
    if (
      this.props.customerCode !== "" &&
      this.props.customerCode !== undefined
    ) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.customerCode = this.props.customerCode;
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: false,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
        isShowClearErrorButton: false,
      });
      this.loadPage(1);
    }
    ModuleUtils.getCreditMemoStatusList();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.loadCustomerStatisticsList(criteria);
  };
  loadCustomerStatisticsList = (criteria) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (!isEmpty(criteria.customerCode)) {
      if (SecurityAccessManager.CustomerStatiticsInquiry_IsAccessible()) {
        ReportService.inquireCustomerStatisticsData(
          criteria,
          this.loadCustomerStatisticsPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    } else {
      let errMsg = "CustomerCode Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCustomerStatisticsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let inquiryData = response.data.result;
      let agingBucketList = [];
      let agingHistoryBean = null;
      let onOrderInfoDetail = [];
      let salesDetail = [];
      let returnCreditMemo = [];
      if (response.data.result.agingBucketGroupBean != null) {
        if (!isEmptyArray(response.data.result.agingBucketGroupBean.buckets)) {
          agingBucketList = response.data.result.agingBucketGroupBean.buckets;
        }
      }
      if (response.data.result.agingHistoryBean != null) {
        agingHistoryBean = response.data.result.agingHistoryBean;
      }
      if (response.data.result.onOrderInfoDetails != null) {
        onOrderInfoDetail = response.data.result.onOrderInfoDetails;
      }
      if (response.data.result.salesDetails != null) {
        salesDetail = response.data.result.salesDetails;
      }
      if (response.data.result.returnCreditMemos != null) {
        returnCreditMemo = response.data.result.returnCreditMemos;
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        agingBucketList: agingBucketList,
        agingHistoryBean: agingHistoryBean,
        onOrderInfoDetail: onOrderInfoDetail,
        salesDetail: salesDetail,
        returnCreditMemo: returnCreditMemo,
        inquiryData: inquiryData,
        isShowCriteriaView: false,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCustomerStatisticsReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerStatisticsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerStatiticsInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerStatisticsPrintReport(
          listRequest,
          this.generateCustomerStatisticsPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerStatiticsInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerStatisticsPrintReport(
          listRequest,
          this.generateCustomerStatisticsPageExcelResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerStatisticsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCustomerStatisticsPageExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
           let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
         window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CustomerStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new CustomerStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      isShowClearCriteriaButton: true,
      inquiryDataList: new Array(),
      isShowCriteriaView: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateCustomerStatisticsReport(1);
  };
  generateExcel = () => {
    this.generateCustomerStatisticsReport(2);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code != undefined && code != null) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCheckBounceModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCheckBounceModule: true,
        moduleForPopup: (
          <PopupCheckBounceModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowSalesModule: isOpen,
      isShowARModule: isOpen,
      isShowCreditMemoModule: isOpen,
      isShowCheckBounceModule: isOpen,
      moduleForPopup: [],
    });
  };
  lastSalesDetailsClick = (e, val) => {
    if (e.detail === 1) {
      let agingHistoryBean = this.state.agingHistoryBean;
      let invoiceDetail = [];
      if (val > 0) {
        if (agingHistoryBean.invoiceDetails != null)
          invoiceDetail = agingHistoryBean.invoiceDetails;
        this.setState({
          isShowLastSalesDetailsPopup: true,
          invoiceDetail: invoiceDetail,
        });
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLastSalesDetailsPopup: isShowPopup,
      isShowTotalReturnPopup: isShowPopup,
      isShowOpenTenderPopup: isShowPopup,
      isShowOpenReturnPopup: isShowPopup,
      isShowDiscountPopup: isShowPopup,
      isShowBouncedCheckPopup: isShowPopup,
    });
  };
  viewTotalReturn = (e, val) => {
    if (e.detail === 1) {
      let criteria = this.state.criteria;
      let listRequest = new RestReadRequest();
      listRequest.companyCode = this.companyCode;
      listRequest.code = criteria.customerCode;
      if (val > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading Total Tender Return",
        });
        CreditMemoService.getCreditMemoListForAvailableCreditData(
          listRequest,
          this.viewTotalReturnAmountPageResponse,
          this.errorCallBack
        );
      }
    }
  };
  viewTotalReturnAmountPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.creditMemoPageList != null) {
      let totalReturnDetails = [];
      if (response.data.creditMemoPageList.creditMemos != null) {
        totalReturnDetails = response.data.creditMemoPageList.creditMemos;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          totalReturnDetails: totalReturnDetails,
          isShowTotalReturnPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  viewOpenDiscount = (e, val) => {
    if (e.detail === 1) {
      let criteria = this.state.criteria;
      let listRequest = new RestReadRequest();
      listRequest.companyCode = this.companyCode;
      listRequest.code = criteria.customerCode;
      if (val > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading Discount",
        });
        CreditMemoService.getCreditMemoListForOpenDiscountCreditData(
          listRequest,
          this.viewDiscountAmountPageResponse,
          this.errorCallBack
        );
      }
    }
  };
  viewDiscountAmountPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.creditMemoPageList != null) {
      let discountDetails = [];
      if (response.data.creditMemoPageList.creditMemos != null) {
        discountDetails = response.data.creditMemoPageList.creditMemos;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          discountDetails: discountDetails,
          isShowDiscountPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  viewOpenReturn = (e, val) => {
    if (e.detail === 1) {
      let criteria = this.state.criteria;
      let listRequest = new RestReadRequest();
      listRequest.companyCode = this.companyCode;
      listRequest.code = criteria.customerCode;
      if (val > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading OpenReturn",
        });
        CreditMemoService.getCreditMemoListForOpenReturnCreditData(
          listRequest,
          this.viewOpenReturnPageResponse,
          this.errorCallBack
        );
      }
    }
  };
  viewOpenReturnPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.creditMemoPageList != null) {
      let openReturnDetails = [];
      if (response.data.creditMemoPageList.creditMemos != null) {
        openReturnDetails = response.data.creditMemoPageList.creditMemos;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          openReturnDetails: openReturnDetails,
          isShowOpenReturnPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  viewOpenTender = (e, val) => {
    if (e.detail === 1) {
      let criteria = this.state.criteria;
      let listRequest = new RestReadRequest();
      listRequest.companyCode = this.companyCode;
      listRequest.code = criteria.customerCode;
      if (val > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading OpenTender",
        });
        CreditMemoService.getCreditMemoListForOpenTenderCreditData(
          listRequest,
          this.viewOpenTenderPageResponse,
          this.errorCallBack
        );
      }
    }
  };
  viewOpenTenderPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.creditMemoPageList != null) {
      let openTenderDetails = [];
      if (response.data.creditMemoPageList.creditMemos != null) {
        openTenderDetails = response.data.creditMemoPageList.creditMemos;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          openTenderDetails: openTenderDetails,
          isShowOpenTenderPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  viewBouncedCheck = (e, val) => {
    if (e.detail === 1) {
      let criteria = this.state.criteria;
      let listRequest = new RestReadRequest();
      listRequest.companyCode = this.companyCode;
      listRequest.code = criteria.customerCode;
      if (val > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading Bounce Check",
        });
        AccountReceivableService.getCheckBounceDetailForCustomerStatistics(
          listRequest,
          this.viewBouncedCheckPageResponse,
          this.errorCallBack
        );
      }
    }
  };
  viewBouncedCheckPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.checkBounceProcessPageList != null
    ) {
      let bouncedCheck = [];
      if (
        response.data.checkBounceProcessPageList.checkBounceProcesses != null
      ) {
        bouncedCheck =
          response.data.checkBounceProcessPageList.checkBounceProcesses;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          bouncedCheck: bouncedCheck,
          isShowBouncedCheckPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomer = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readCustomerResponse,
      this.errorCallBack
    );
  };
  readCustomerResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceQty", "invoiceQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "salesAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  onOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "salesOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "salesOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnOrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  returnPaymentColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemoDate", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalCreditAmt", "totalCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmt", "appliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReturnedAmt", "returnAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BalanceAmt", "appliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "creditMemoStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption)
    );
    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getCreditMemoStatusCaption(status);
  };
  lastSalesDetailsColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerPO#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "invoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaymentDueDate", "invoicePaymentDueDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PaymentMethod", "paymentMethod", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesClerk", "salesClerk", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCodes", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceType", "invoiceType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  getLineCaption = (status) => {
    return ModuleUtils.getCreditMemoStatusCaption(status);
  };
  totalReturnsDetailsColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemoDate", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditType#", "creditType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubType", "subType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Merchandise Amt", "merchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NonMerchandise Amt", "nonMerchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalCreditAmt", "totalCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "creditMemoStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  openDiscountColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemoDate", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditType#", "creditType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubType", "subType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Merchandise Amt", "merchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NonMerchandise Amt", "nonMerchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalCreditAmt", "totalCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "creditMemoStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  openReturnColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemoDate", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditType#", "creditType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubType", "subType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Merchandise Amt", "merchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NonMerchandise Amt", "nonMerchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalCreditAmt", "totalCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "creditMemoStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  openTenderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemoDate", "creditMemoDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCreditMemoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditType#", "creditType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubType", "subType", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Merchandise Amt", "merchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NonMerchandise Amt", "nonMerchandiseCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalCreditAmt", "totalCreditAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "creditMemoStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  bouncedCheckColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "checkBounceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckBounce#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCheckBounceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Check#", "checkNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckAmt", "checkAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Check Date", "checkDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Issued Bank", "issuedBankName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getBouncedCheckCaption)
    );
    return columns;
  };
  getBouncedCheckCaption = (status) => {
    return ModuleUtils.getCreditMemoStatusCaption(status);
  };
  render() {
    let agingBucketList = this.state.agingBucketList;
    let agingHistoryBean = this.state.agingHistoryBean;
    let onOrderInfoDetail = this.state.onOrderInfoDetail;
    let salesDetail = this.state.salesDetail;
    let returnCreditMemo = this.state.returnCreditMemo;
    let criteria = this.state.criteria;
    let inquiryData = this.state.inquiryData;
    let invoiceDetail = this.state.invoiceDetail;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        {this.state.isShowCriteriaView && (
          <CriteriaView
            {...this.state}
            loadPage={this.loadPage}
            onChange={this.onChange}
            customerLookupHandler={this.state.customerLookupHandler}
            customerCodeOnChange={this.customerCodeOnChange}
            customerCodeRef={this.customerCodeRef}
            customerCodeEnterKeyEventHandler={
              this.customerCodeEnterKeyEventHandler
            }
            displayAutoCompleteList={this.displayAutoCompleteList}
          />
        )}
        {this.state.isInquiryDatasFound && (
          <div>
            <div className="customer_statistics_grid1">
              <div>
                <div>
                  <Row className="d-flex justify-content-left">
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="customerCode"
                        placeholder="customerCode"
                        onChange={this.onChange}
                        value={criteria.customerCode}
                      />
                    </Col>
                    <Col sm="2">
                      <FormLabel>CustomerName</FormLabel>
                    </Col>
                    <Col sm="6">
                      <InputTextbox
                        name="customerName"
                        placeholder="customerName"
                        onChange={this.onChange}
                        value={criteria.customerName}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Currency</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="currencyCode"
                        placeholder="currencyCode"
                        onChange={this.onChange}
                        value={agingHistoryBean.companyCurrencyCode}
                        className=" summary_input"
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>TotalDue</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        onChange={this.onChange}
                        value={agingHistoryBean.totalInvoiceDueAmount}
                        className="qty_input text-right summary_input"
                        decimalScale={2}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>UnApplied Credit</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        onChange={this.onChange}
                        value={agingHistoryBean.totalUnAppliedCreditMemoAmount}
                        className="qty_input text-right summary_input"
                        decimalScale={2}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="customer_grid_rows">
                  <div>
                    <Row>
                      <FormLabel>Past Sales Transaction</FormLabel>
                    </Row>
                    <Row>
                      <Col sm="5">
                        <FormLabel
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.lastSalesDetailsClick(
                              e,
                              inquiryData.lastThreeMonthsSalesAmount
                            )
                          }
                        >
                          Last3monthSales
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.lastThreeMonthsSalesAmount}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="5">
                        <FormLabel
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.lastSalesDetailsClick(
                              e,
                              inquiryData.lastSixMonthsSalesAmount
                            )
                          }
                        >
                          Last6MonthSales
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.lastSixMonthsSalesAmount}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="5">
                        <FormLabel
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.lastSalesDetailsClick(
                              e,
                              inquiryData.lastTwelveMonthsSalesAmount
                            )
                          }
                        >
                          Last12MonthSales
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.lastTwelveMonthsSalesAmount}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="5">
                        <FormLabel
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.lastSalesDetailsClick(
                              e,
                              inquiryData.lastEighteenMonthsSalesAmount
                            )
                          }
                        >
                          Last18MonthSales
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.lastEighteenMonthsSalesAmount}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="5">
                        <FormLabel
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.lastSalesDetailsClick(
                              e,
                              inquiryData.lastTwentyFourMonthsSalesAmount
                            )
                          }
                        >
                          Last24MonthSales
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.lastTwentyFourMonthsSalesAmount}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row>
                      <FormLabel>Aging Info</FormLabel>
                    </Row>
                    <div className="table_small">
                      <Table id="fabrics_tables">
                        <thead>
                          {agingBucketList.map((list, index) => (
                            <th>{list.code}</th>
                          ))}
                        </thead>
                        <tbody>
                          <tr>
                            <td>{agingHistoryBean.currentAgeAmount}</td>
                            <td>{agingHistoryBean.ageAmount1}</td>
                            <td>{agingHistoryBean.ageAmount2}</td>
                            <td>{agingHistoryBean.ageAmount3}</td>
                            <td>{agingHistoryBean.ageAmount4}</td>
                          </tr>
                        </tbody>
                      </Table>
                      {agingBucketList.length != 0 ? null : (
                        <div className="no_Data">{"NO DATA"}</div>
                      )}
                    </div>
                    <Row>
                      <FormLabel>Bounced Checks</FormLabel>
                    </Row>
                    <Row>
                      <Col sm="4">
                        <FormLabel> BouncedCheck[Count]</FormLabel>
                      </Col>
                      <Col sm="4">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.noOfBouncedCheck}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="4">
                        <FormLabel
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewBouncedCheck(
                              e,
                              inquiryData.totalBouncedcheckAmount
                            )
                          }
                        >
                          {" "}
                          BouncedCheck[Amount]
                        </FormLabel>
                      </Col>
                      <Col sm="4">
                        <NumberFormatInputbox
                          onChange={this.onChange}
                          value={inquiryData.totalBouncedcheckAmount}
                          className="qty_input text-right summary_input"
                          decimalScale={2}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <div>
                <Row>
                  <FormLabel>Credit Amount</FormLabel>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.viewOpenTender(
                          e,
                          inquiryData.openTenderCreditAmount
                        )
                      }
                    >
                      OpenTenderAmount
                    </FormLabel>
                  </Col>
                  <Col sm="6">
                    <NumberFormatInputbox
                      onChange={this.onChange}
                      value={inquiryData.openTenderCreditAmount}
                      className="qty_input text-right summary_input"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.viewOpenReturn(
                          e,
                          inquiryData.openReturnCreditAmount
                        )
                      }
                    >
                      OpenReturnAmount
                    </FormLabel>
                  </Col>
                  <Col sm="6">
                    <NumberFormatInputbox
                      onChange={this.onChange}
                      value={inquiryData.openReturnCreditAmount}
                      className="qty_input text-right summary_input"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.viewOpenDiscount(
                          e,
                          inquiryData.openDiscountCreditAmount
                        )
                      }
                    >
                      OpenDiscountAmount
                    </FormLabel>
                  </Col>
                  <Col sm="6">
                    <NumberFormatInputbox
                      onChange={this.onChange}
                      value={inquiryData.openDiscountCreditAmount}
                      className="qty_input text-right summary_input"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.viewTotalReturn(e, inquiryData.totalReturnsAmount)
                      }
                    >
                      TotalReturnAmount
                    </FormLabel>
                  </Col>
                  <Col sm="6">
                    <NumberFormatInputbox
                      onChange={this.onChange}
                      value={inquiryData.totalReturnsAmount}
                      className="qty_input text-right summary_input"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <FormLabel>Last Payment Info </FormLabel>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel>LastPaidDate</FormLabel>
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={inquiryData.lastPaidDate}
                      className=" summary_input"
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.viewARModule(
                          e,
                          inquiryData.lastAccountReceivableNumber
                        )
                      }
                    >
                      LastAR#
                    </FormLabel>
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={inquiryData.lastAccountReceivableNumber}
                      className="summary_input"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="4">
                    <FormLabel>LastPaidAmount</FormLabel>
                  </Col>
                  <Col sm="6">
                    <NumberFormatInputbox
                      value={inquiryData.lastPaidAmount}
                      className="qty_input text-right summary_input"
                      decimalScale={2}
                      disabled={true}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div className="div_inline">
              <div className="div_Equal_no_height">

                <div className="mt-3">
                  <CustomTable
                    data={salesDetail}
                    columns={this.inquiryColumns()}
                    label={"Sales Details"}
                  />
                </div>
              </div>
              <div className="div_Equal_no_height">
                <div className="div_Custom">
                  <div className="mt-3">
                    <CustomTable
                      data={onOrderInfoDetail}
                      columns={this.onOrderColumns()}
                      label={"OnOrderDetails"}
                    />
                  </div>
                </div>
                <div className="div_Custom">
                  <div className="mt-3">
                    <CustomTable
                      data={returnCreditMemo}
                      columns={this.returnPaymentColumns()}
                      label={"ReturnPaymentDetails"}
                    />
                  </div>
                </div>
              </div>
            </div>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowLastSalesDetailsPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel3"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Last Sales Details"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="">
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={agingHistoryBean.companyCode}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={agingHistoryBean.customerCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={invoiceDetail}
                      columns={this.lastSalesDetailsColumns()}
                    />
                  </div>
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowTotalReturnPopup}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              popupLvlClass={"popupSizeLevel3"}
              title={"Last Available credits creditMemo"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="">
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.companyCode}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.customerCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={this.state.totalReturnDetails}
                      columns={this.totalReturnsDetailsColumns()}
                    />
                  </div>
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowDiscountPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel3"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Last Discount Details creditMemo"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="">
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.companyCode}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.customerCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={this.state.discountDetails}
                      columns={this.openDiscountColumns()}
                    />
                  </div>
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowOpenReturnPopup}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              popupLvlClass={"popupSizeLevel3"}
              title={"Last Open Return creditMemo"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="">
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.companyCode}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.customerCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={this.state.openReturnDetails}
                      columns={this.openReturnColumns()}
                    />
                  </div>
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowOpenTenderPopup}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              popupLvlClass={"popupSizeLevel3"}
              title={"Last Open Tender creditMemo"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="">
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.companyCode}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={criteria.customerCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={this.state.openTenderDetails}
                      columns={this.openTenderColumns()}
                    />
                  </div>
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowBouncedCheckPopup}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              popupLvlClass={"popupSizeLevel2"}
              title={"Bounced Check"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="mt-3">
                  <CustomTable
                    data={this.state.bouncedCheck}
                    columns={this.bouncedCheckColumns()}
                  />
                </div>
              }
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCheckBounceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  let isShowCriteriaView = props.isShowCriteriaView;
  const customerCodeRef = props.customerCodeRef;
  let isDisableFields = props.isDisableFields;
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  return (
    <div>
      {isShowCriteriaView && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={customerCodeRef}
              name="customerCode"
              placeholder="customer"
              onChange={customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={customerCodeEnterKeyEventHandler}
              autoCompleteListData={props.customerPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteList}
              showAutoCompleteList={props.showAutoCompleteCustomerList}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              onChange={onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function CustomerStatisticsInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerStatistics {...props} name="" /> <br />
    </div>
  );
}

export default CustomerStatisticsInquiry;
